
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchPublicUsers, getMultiplePublicProfiles, PublicProfile } from '../services/secureProfileService';

// 🔒 SECURE PUBLIC USER SEARCH HOOK
export const usePublicUserSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const { data: searchResults = [], isLoading, error } = useQuery({
    queryKey: ['public-users-search', searchTerm],
    queryFn: () => searchPublicUsers(searchTerm),
    enabled: searchTerm.trim().length >= 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    searchResults,
    searchTerm,
    setSearchTerm,
    isLoading,
    error,
    hasResults: searchResults.length > 0,
    canSearch: searchTerm.trim().length >= 2,
  };
};

// 🔒 SECURE BULK PROFILE FETCH HOOK
export const usePublicProfiles = (userIds: string[]) => {
  const { data: profiles = [], isLoading, error } = useQuery({
    queryKey: ['public-profiles', userIds],
    queryFn: () => getMultiplePublicProfiles(userIds),
    enabled: userIds.length > 0,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return {
    profiles,
    isLoading,
    error,
    getProfileById: (userId: string): PublicProfile | undefined => 
      profiles.find(profile => profile.id === userId),
  };
};
